export const USE_DOC_FLOW_EPOST_SETTINGS_ASYNC_ID = 'epostloading'

export const USE_DOC_FLOW_EPOST_SETTINGS_ASYNC_TIME_OUT = 2000
